import React, { lazy } from "react";
const BullkEnquiry = lazy(() =>
  import("../Component/Website/BullkEnquiry/BullkEnquiry")
);
const ContactUs = lazy(() =>
  import("../Component/Website/ContactUs/ContactUs")
);
const EditProduct = lazy(() =>
  import("../Component/Admin/Products/Product/EditProduct")
);
const ViewProduct = lazy(() =>
  import("../Component/Admin/Products/Product/ViewProduct")
);
const Checkout = lazy(() => import("../Component/Website/Checkout/Checkout"));
const OrderDetails = lazy(() =>
  import("../Component/Website/MyAccount/OrderDetails")
);
const MyAccount = lazy(() =>
  import("../Component/Website/MyAccount/MyAccount")
);
const Orders = lazy(() => import("../Component/Website/MyAccount/Orders"));
const Address = lazy(() => import("../Component/Website/MyAccount/Address"));
const OrdersList = lazy(() =>
  import("../Component/Admin/Orders/Orders/OrdersList")
);
const Test = lazy(() => import("../Component/Dashboard/Test"));
const Home = lazy(() => import("../Component/Website/Home/Home"));
const SingleProduct = lazy(() =>
  import("../Component/Website/SingleProduct/SingleProduct")
);
const Brand = lazy(() =>
  import("../Component/Admin/Products/Brands/BrandList")
);
const Courier = lazy(() =>
  import("../Component/Admin/Products/Courier/CourierList")
);
const Category = lazy(() =>
  import("../Component/Admin/Products/Category/CategoryList")
);
const Product = lazy(() =>
  import("../Component/Admin/Products/Product/ProductList")
);
const AddProduct = lazy(() =>
  import("../Component/Admin/Products/Product/AddProduct")
);
const Cart = lazy(() => import("../Component/Website/Cart/Cart"));
const PaySuccess = lazy(() =>
  import("../Component/Website/Checkout/PaySuccess")
);
const PayFailed = lazy(() => import("../Component/Website/Checkout/PayFailed"));
const Shop = lazy(() => import("../Component/Website/Shop/Shop"));
const BlogCategory = lazy(() =>
  import("../Component/Admin/Blog/Category/BlogCategoryList")
);
const AboutUs = lazy(() =>
  import("../Component/Website/Pages/AboutUs/AboutUs")
);
const Benefits = lazy(() =>
  import("../Component/Website/Pages/Benefits/Benefits")
);
const Testimonials = lazy(() =>
  import("../Component/Website/Pages/Testimonials/Testimonials")
);
const OurJourney = lazy(() =>
  import("../Component/Website/Pages/OurJourney/OurJourney")
);
const TermsAndConditions = lazy(() =>
  import("../Component/Website/Pages/Policy/TermsAndConditions")
);
const DeliveryInformation = lazy(() =>
  import("../Component/Website/Pages/Policy/DeliveryInformation")
);
const BlogList = lazy(() => import("../Component/Website/Blog/BlogList"));
const BlogDetails = lazy(() => import("../Component/Website/Blog/BlogDetails"));
const ViewOrders = lazy(() =>
  import("../Component/Admin/Orders/Orders/ViewOrders")
);
const Ratings = lazy(() => import("../Component/Admin/Rating/RatingList"));
const CommonSettings = lazy(() => import("../Component/Admin/Freecash/CommonSettings"));
const FreecashHistory = lazy(() => import("../Component/Admin/Freecash/FreecashHistory"));
const Freecash = lazy(() => import("../Component/Admin/Freecash/FreecashList"));
const AddFreecash = lazy(() =>
  import("../Component/Admin/Freecash/AddFreecash")
);
const EditFreecash = lazy(() =>
  import("../Component/Admin/Freecash/EditFreecash")
);
const ViewFreecash = lazy(() =>
  import("../Component/Admin/Freecash/ViewFreecash")
);
const Thankyou = lazy(() => import("../Component/Website/ContactUs/Thankyou"));
const CustomerList = lazy(() =>
  import("../Component/Admin/Customers/CustomerList")
);
const CustomerDetails = lazy(() =>
  import("../Component/Admin/Customers/CustomersDetails")
);
const AnOverview = lazy(() => import("../Component/Analytics/AnOverview"));
const AnProducts = lazy(() => import("../Component/Analytics/AnProducts"));
const AnCustomers = lazy(() => import("../Component/Analytics/AnCustomers"));
const AnRevenue = lazy(() => import("../Component/Analytics/AnRevenue"));
const AnOrders = lazy(() => import("../Component/Analytics/AnOrders"));
const AnCoupons = lazy(() => import("../Component/Analytics/AnCoupons"));
const AnMonthlyReports = lazy(() =>
  import("../Component/Analytics/AnMonthlyReports")
);
const ReOrdersList = lazy(() =>
  import("../Component/Admin/Orders/Orders/ReOrderList")
);
const BannerTables = lazy(() => import("../Component/Admin/Banner/BannerTables"));
const Refund = lazy(() => import("../Component/Website/Pages/Policy/Refund"));
const Return = lazy(() => import("../Component/Website/Pages/Policy/Return"));
const Shipping = lazy(() => import("../Component/Website/Pages/Policy/Shipping"));
const PrivacyPolicy = lazy(() => import("../Component/Website/Pages/Policy/PrivacyPolicy"));
const CheckoutPhone = lazy(() => import("../Component/Website/Checkout/CheckoutPhone"));

const PaySuccessPhone = lazy(() => import("../Component/Website/Checkout/PaySuccessPhone"));
const get_role = () => {
  const role = localStorage.getItem("nattu_admin_role");
  return role;
};
export const authRoutes = [
  {
    path: "/",
    exact: true,
    element: get_role() === "staff" ? <div>You don't have permission</div> : <Test />,
  },
  {
    path: "/banner/banner",
    exact: true,
    element: <BannerTables />,
  },
  {
    path: "/products/brands",
    exact: true,
    element: <Brand />,
  },
  {
    path: "/products/couriers",
    exact: true,
    element: <Courier />,
  },
  {
    path: "/products/category",
    exact: true,
    element: <Category />,
  },
  {
    path: "/products/products",
    exact: true,
    element: <Product />,
  },
  {
    path: "/products/products/add_product",
    exact: true,
    element: <AddProduct />,
  },
  {
    path: "/products/products/edit_product/:id",
    exact: true,
    element: <EditProduct />,
  },
  {
    path: "/products/products/view_product/:id",
    exact: true,
    element: <ViewProduct />,
  },
  {
    path: "/orders/sales",
    exact: true,
    element: <OrdersList />,
  },
  {
    path: "/orders/reorders",
    exact: true,
    element: <ReOrdersList />,
  },
  {
    path: "/blog/category",
    exact: true,
    element: <BlogCategory />,
  },
  {
    path: "/orders/sales/:oid",
    exact: true,
    element: <ViewOrders />,
  },
  {
    path: "/ratings",
    exact: true,
    element: <Ratings />,
  },
  {
    path: "/freecash/history",
    exact: true,
    element: <FreecashHistory />,
  },
  {
    path: "/freecash/common_settings",
    exact: true,
    element: <CommonSettings />,
  },
  {
    path: "/freecash",
    exact: true,
    element: <Freecash />,
  },
  {
    path: "/freecash/add_freecash",
    exact: true,
    element: <AddFreecash />,
  },
  {
    path: "/freecash/edit_freecash/:id",
    exact: true,
    element: <EditFreecash />,
  },
  {
    path: "/freecash/view_freecash/:id",
    exact: true,
    element: <ViewFreecash />,
  },
  {
    path: "/customers",
    exact: true,
    element: <CustomerList />,
  },
  {
    path: "/customers/customer_details/:id",
    exact: true,
    element: <CustomerDetails />,
  },
  {
    path: "/analytics/overview",
    exact: true,
    element: <AnOverview />,
  },
  {
    path: "/analytics/products",
    exact: true,
    element: <AnProducts />,
  },
  {
    path: "/analytics/revenue",
    exact: true,
    element: <AnRevenue />,
  },
  {
    path: "/analytics/orders",
    exact: true,
    element: <AnOrders />,
  },
  {
    path: "/analytics/coupons",
    exact: true,
    element: <AnCoupons />,
  },
  {
    path: "/analytics/customers",
    exact: true,
    element: <AnCustomers />,
  },
  {
    path: "/analytics/monthly_report",
    exact: true,
    element: <AnMonthlyReports />,
  },
  
];

export const authRoutesStaff = [
  {
    path: "/",
    exact: true,
    element:
      get_role() === "staff" ? <div>You don't have permission</div> : <Test />,
  },
  {
    path: "/orders/sales",
    exact: true,
    element: <OrdersList />,
  },
  {
    path: "/orders/reorders",
    exact: true,
    element: <ReOrdersList />,
  },
  {
    path: "/orders/sales/:oid",
    exact: true,
    element: <ViewOrders />,
  },
  
];

export const webRoutes = [
  {
    path: "/refund-policy",
    exact: true,
    element: <Refund />,
  },
  {
    path: "/return-policy",
    exact: true,
    element: <Return />,
  },
  {
    path: "/shipping-policy",
    exact: true,
    element: <Shipping />,
  },
  {
    path: "/privacy-policy",
    exact: true,
    element: <PrivacyPolicy />,
  },
  {
    path: "/",
    exact: true,
    element: <Home />,
  },
  {
    path: "/product/:id",
    exact: true,
    element: <SingleProduct />,
  },
  {
    path: "/products",
    exact: true,
    element: <Shop />,
  },
  {
    path: "/about-us",
    exact: true,
    element: <AboutUs />,
  },
  {
    path: "/benefits-of-naatu-sakkarai",
    exact: true,
    element: <Benefits />,
  },
  {
    path: "/testimonials",
    exact: true,
    element: <Testimonials />,
  },
  {
    path: "/our-journey",
    exact: true,
    element: <OurJourney />,
  },
  {
    path: "/terms-conditions",
    exact: true,
    element: <TermsAndConditions />,
  },
  {
    path: "/delivery-information",
    exact: true,
    element: <DeliveryInformation />,
  },
  {
    path: "/blog",
    exact: true,
    element: <BlogList />,
  },
  {
    path: "/blog/:blog_slug",
    exact: true,
    element: <BlogDetails />,
  },
  {
    path: "/contact-us",
    exact: true,
    element: <ContactUs />,
  },
  {
    path: "/bulk-enquiry",
    exact: true,
    element: <BullkEnquiry />,
  },
  {
    path: "/thank-you",
    exact: true,
    element: <Thankyou />,
  },
];

export const wenAuthRoute = [
  {
    path: "/cart",
    exact: true,
    element: <Cart />,
  },
  {
    path: "/checkout",
    exact: true,
    element: <CheckoutPhone />, //CheckoutPhone Checkout
  },
  // {
  //   path: "/checkout_phone",
  //   exact: true,
  //   element: <CheckoutPhone />,
  // },
  {
    path: "/myaccount/profile",
    exact: true,
    element: <MyAccount />,
  },
  {
    path: "/myaccount/orders",
    exact: true,
    element: <Orders />,
  },
  {
    path: "/myaccount/order-details/:oid",
    exact: true,
    element: <OrderDetails />,
  },
  {
    path: "/myaccount/address",
    exact: true,
    element: <Address />,
  },
  {
    path: "/success",
    exact: true,
    element: <PaySuccessPhone />, //PaySuccessPhone  PaySuccess
  },
  // {
  //   path: "/success_phone",
  //   exact: true,
  //   element: <PaySuccessPhone />,
  // },
  {
    path: "/failed",
    exact: true,
    element: <PayFailed />,
  },
];
